import { createSlice } from "@reduxjs/toolkit";
import get from "lodash/get";
import { ENABLE_REACT_CUSTOMER_MODAL } from "@/env";

export const name = "customer";

const initialState = {
  customer: null,
  /**
   * Part of TAP-2231 - Building a customer object, using the newest conventions
   * of both the BE and the FE codebases. This will be set in tandem with the
   * old "customer" object.
   */
  reactCustomer: null,
  tenantId: null,
  pbxId: null,
  isDialogVisible: false,
  /**
   * Controls whether the React front-end should skip the next sync event.
   * This is done in order to stop double-updates, where a React update
   * triggers twice: one initial update and one "reflected" update,
   * generated by Vue notifying React its customer state changed.
   */
  skipNextSync: false,
};

const customerSlice = createSlice({
  name,
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      state.customer = action.payload;
    },
    setReactCustomer: (state, action) => {
      state.reactCustomer = action.payload;
    },
    setTenantId: (state, action) => {
      state.tenantId = action.payload;
    },
    setPbxId: (state, action) => {
      state.pbxId = action.payload;
    },
    openCustomerSelectModal: (state) => {
      state.isDialogVisible = true;
    },
    closeCustomerSelectModal: (state) => {
      state.isDialogVisible = false;
    },
    setSkipNextSync: (state, action) => {
      state.skipNextSync = action.payload;
    },
  },
});

export const {
  setCustomer,
  setReactCustomer,
  setTenantId,
  setPbxId,
  openCustomerSelectModal,
  closeCustomerSelectModal,
  setSkipNextSync,
} = customerSlice.actions;

export const customerSelector = (state) => state[name].customer;
export const customerIdSelector = (state) => customerSelector(state)?.cid;
export const selectReactCustomer = (state) => state[name].reactCustomer;

export const tenantSelector = (state) =>
  customerSelector(state)?.tenantInfo?.find(
    (tenant) => tenant.tenantId === tenantIdSelector(state)
  );
export const tenantIdSelector = (state) =>
  state[name].tenantId ||
  get(customerSelector(state), "tenantInfo[0].tenantId");

export const pbxNameSelector = (state) => {
  if (ENABLE_REACT_CUSTOMER_MODAL) {
    return selectReactCustomer(state)?.pbxMap[pbxIdSelector(state)];
  } else {
    const pbxEntry = customerSelector(state)?.pbxList.find(
      (entry) => entry.id === pbxIdSelector(state)
    );
    return pbxEntry?.name;
  }
};
export const pbxIdSelector = (state) => state[name].pbxId;

export const selectIsCustomerModalVisible = (state) =>
  state[name].isDialogVisible;

export const selectSkipNextSync = (state) => state[name].skipNextSync;

export default customerSlice.reducer;
